import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { ProductAdvisorProvider, ProductAdvisorPanel, FloatingAdvisorButton } from "./components/feature/ProductAdvisor";
import { DemoRequestProvider, DemoRequestModal } from "./components/feature/DemoRequest";

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <DemoRequestProvider>
          <ProductAdvisorProvider>
            <AppRoutes />
            <ProductAdvisorPanel />
            <FloatingAdvisorButton />
            <DemoRequestModal />
          </ProductAdvisorProvider>
        </DemoRequestProvider>
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
